"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4505],{

/***/ 254505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DotIndicatorComponent": function() { return /* binding */ DotIndicatorComponent; },
  "default": function() { return /* binding */ CarouselIndicator; },
  "useGetChevronComponent": function() { return /* binding */ useGetChevronComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CardFrameCollection/components/svg.tsx
var svg = __webpack_require__(869466);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(682492);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var common = __webpack_require__(720901);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/utils.ts
var utils = __webpack_require__(24200);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/hooks/useGetElementRects.ts


function useGetElementRects(param) {
    var _elementRef = param.elementRef, elementRef = _elementRef === void 0 ? null : _elementRef, _dependency = param.dependency, dependency = _dependency === void 0 ? [] : _dependency;
    var ref = (0,react.useState)({
        elementRect: {
            scrollWidth: 0,
            clientWidth: 0,
            clientHeight: 0
        },
        timeChanged: 0
    }), itemContainerLayoutChange = ref[0], setItemContainerLayoutChange = ref[1];
    (0,react.useEffect)(function() {
        if (elementRef) {
            setItemContainerLayoutChange({
                elementRect: {
                    scrollWidth: elementRef.scrollWidth,
                    clientWidth: elementRef.clientWidth,
                    clientHeight: elementRef.clientHeight
                },
                timeChanged: Date.now()
            });
            var resizeObserverInst = new ResizeObserver(function() {
                var ref = elementRef || {}, clientWidth = ref.clientWidth, scrollWidth = ref.scrollWidth, clientHeight = ref.clientHeight;
                setItemContainerLayoutChange({
                    elementRect: {
                        scrollWidth: scrollWidth,
                        clientWidth: clientWidth,
                        clientHeight: clientHeight
                    },
                    timeChanged: Date.now()
                });
            });
            elementRef && resizeObserverInst.observe(elementRef);
            return function() {
                return elementRef && resizeObserverInst.unobserve(elementRef);
            };
        }
    }, [
        elementRef
    ].concat((0,_to_consumable_array/* default */.Z)(dependency)));
    return [
        itemContainerLayoutChange
    ];
}

// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/context/ListPresentationContext.tsx + 15 modules
var ListPresentationContext = __webpack_require__(101657);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/useWidgetDndData.ts + 3 modules
var useWidgetDndData = __webpack_require__(227506);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/CardFrameCollection/components/CarouselIndicator.tsx














var GAP = 36;
function CarouselIndicator(param) {
    var onNextArrowClick = param.onNextArrowClick, onPrevArrowClick = param.onPrevArrowClick;
    var _RenderSlider = function _RenderSlider() {
        switch(progressIndicator){
            case "fullWidthBar":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderComponent, {
                        width: "100%",
                        scrollPercentage: scrollPercentage,
                        progressIndicatorColor: progressIndicatorColor
                    });
                }
            case "shortProgressBar":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderComponent, {
                    height: "5px",
                    width: "132px",
                    scrollPercentage: scrollPercentage,
                    progressIndicatorColor: progressIndicatorColor
                });
            case "dashAndDots":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DotIndicatorComponent, {
                    overflowSectionCount: overflowSectionCount,
                    currentFocusedSectionItem: Math.round(currentFocusedSectionExact),
                    progressIndicatorColor: progressIndicatorColor,
                    direction: direction
                });
            default:
                return null;
        }
    };
    var _RenderArrows = function _RenderArrows() {
        var ref, ref1;
        var showArrow = showArrowUI && !arrowPositionKT.isTop;
        var arrowVerticalPositionOffset = ((ref = layoutWrapperLayoutChange.elementRect) === null || ref === void 0 ? void 0 : ref.clientHeight) + (!Slider ? -GAP : 0) + (itemContainerLayoutChange === null || itemContainerLayoutChange === void 0 ? void 0 : (ref1 = itemContainerLayoutChange.elementRect) === null || ref1 === void 0 ? void 0 : ref1.clientHeight) / 2;
        return {
            LeftArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftArrow, {
                isVisible: showArrow,
                className: arrowPositionKT.isCenter ? "tw-absolute tw-left-[-20px] tw-z-10 tw-translate-y-[-50%]" : "",
                style: {
                    bottom: arrowVerticalPositionOffset
                }
            }),
            RightArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrow, {
                isVisible: showArrow,
                className: arrowPositionKT.isCenter ? "tw-absolute tw-right-[-20px] tw-z-10 tw-translate-y-[-50%]" : "",
                style: {
                    bottom: arrowVerticalPositionOffset
                }
            })
        };
    };
    var data = (0,ListPresentationContext/* useListPresentationContextData */.ds)();
    var isMobile = data.state.isMobile;
    var itemContainerRef = data.refs.itemContainerRef;
    var getConfigsAndUtils = data.utilities.getConfigsAndUtils;
    var _generalValues = getConfigsAndUtils().generalValues, showArrow = _generalValues.showArrow, showCarouselIndicators = _generalValues.showCarouselIndicators, contentHorizontalPadding = _generalValues.contentHorizontalPadding, carouselConfigs = _generalValues.carouselConfigs, carouselIndicatorConfigs = _generalValues.carouselIndicatorConfigs;
    var ref = (0,useWidgetDndData/* useWidgetDndData */.K)(), _widgetContextState = ref.widgetContextState, isBuilder = _widgetContextState.isBuilder, previewDevice = _widgetContextState.previewDevice;
    var showArrowUI = showArrow;
    var isVisible = showCarouselIndicators;
    var config = carouselConfigs;
    var arrowPosition = carouselConfigs === null || carouselConfigs === void 0 ? void 0 : carouselConfigs.arrowPosition;
    var ref1 = (0,_sliced_to_array/* default */.Z)(useGetElementRects({
        elementRef: itemContainerRef
    }), 1), itemContainerLayoutChange = ref1[0];
    var ref2 = carouselIndicatorConfigs || {}, direction = ref2.direction, _scrollPercentage = ref2.scrollPercentage, scrollPercentage = _scrollPercentage === void 0 ? 0 : _scrollPercentage, _overflowSectionCount = ref2.overflowSectionCount, overflowSectionCount = _overflowSectionCount === void 0 ? 0 : _overflowSectionCount, _currentFocusedSectionExact = ref2.currentFocusedSectionExact, currentFocusedSectionExact = _currentFocusedSectionExact === void 0 ? 0 : _currentFocusedSectionExact;
    var ref3 = config || {}, progressIndicator = ref3.progressIndicator, arrowShape = ref3.arrowShape, _progressIndicatorColor = ref3.progressIndicatorColor, progressIndicatorColor = _progressIndicatorColor === void 0 ? "#111C36" : _progressIndicatorColor;
    var ref4 = (0,react.useState)(null), layoutWrapperRef = ref4[0], setLayoutWrapperRef = ref4[1];
    var layoutWrapperRefCallback = (0,react.useCallback)(function(node) {
        if (!node) return;
        setLayoutWrapperRef(node);
    }, []);
    var ref5 = (0,_sliced_to_array/* default */.Z)(useGetElementRects({
        elementRef: layoutWrapperRef,
        dependency: [
            isBuilder,
            previewDevice
        ]
    }), 1), layoutWrapperLayoutChange = ref5[0];
    var ref6 = useGetChevronComponent({
        type: arrowShape,
        onNextArrowClick: onNextArrowClick,
        onPrevArrowClick: onPrevArrowClick,
        scrollPercentage: scrollPercentage,
        isMobile: isMobile,
        colorConfig: {
            arrowColor: config.arrowColor,
            shapeColor: config.shapeColor
        }
    }), LeftArrow = ref6.LeftArrow, RightArrow = ref6.RightArrow;
    if (!isVisible) {
        return null;
    }
    var arrowPositionKT = {
        isTop: !isMobile ? arrowPosition === "top" : false,
        isCenter: !isMobile ? arrowPosition === "center" : false,
        isBottom: !isMobile ? arrowPosition === "bottom" : true
    };
    var Slider = _RenderSlider();
    var GAP_APPLIED = Slider || arrowPositionKT.isBottom ? 36 : 0;
    var Arrows = _RenderArrows();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: layoutWrapperRefCallback,
        className: "tw-relative tw-mx-auto tw-flex tw-w-[100%] tw-select-none tw-items-center tw-justify-center tw-gap-[20px]",
        style: {
            marginTop: "".concat(GAP_APPLIED, "px"),
            padding: "0px ".concat(contentHorizontalPadding, "px")
        },
        children: [
            Arrows.LeftArrow,
            Slider,
            Arrows.RightArrow
        ]
    });
}
function SliderComponent(param) {
    var _height = param.height, height = _height === void 0 ? "2px" : _height, width = param.width, scrollPercentage = param.scrollPercentage, progressIndicatorColor = param.progressIndicatorColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-relative tw-rounded-[6px] tw-bg-[#111C361F]",
        style: {
            width: width,
            height: height,
            transform: "translateY(".concat(-height / 2, ")")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-absolute tw-h-[100%] tw-rounded-[6px] tw-transition-all",
            style: {
                width: "".concat(scrollPercentage, "%"),
                background: progressIndicatorColor
            }
        })
    });
}
var CONTAINER_WIDTH = 120;
function DotIndicatorComponent(param) {
    var _overflowSectionCount = param.overflowSectionCount, overflowSectionCount = _overflowSectionCount === void 0 ? 0 : _overflowSectionCount, currentFocusedSectionItem = param.currentFocusedSectionItem, progressIndicatorColor = param.progressIndicatorColor, direction = param.direction, _containerWidth = param.containerWidth, containerWidth = _containerWidth === void 0 ? CONTAINER_WIDTH : _containerWidth, _styles = param.styles, styles = _styles === void 0 ? {} : _styles, _dimensions = param.dimensions, dimensions = _dimensions === void 0 ? {
        width: "tw-w-[5px]",
        widthOfSelected: "tw-w-[30px]",
        height: "tw-h-[5px]"
    } : _dimensions;
    var dotsContainerRef = (0,react.useRef)(null);
    var dotsRef = (0,react.useRef)([]);
    (0,react.useEffect)(function() {
        var ref;
        var selectedIndex = currentFocusedSectionItem - 1;
        var selectedDotElement = (ref = dotsRef.current) === null || ref === void 0 ? void 0 : ref[selectedIndex];
        if (dotsContainerRef.current) {
            var ref1, ref2;
            dotsContainerRef.current.scrollTo({
                left: ((ref1 = dotsContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollLeft) + (selectedDotElement === null || selectedDotElement === void 0 ? void 0 : selectedDotElement.getBoundingClientRect().left) - ((ref2 = dotsContainerRef.current) === null || ref2 === void 0 ? void 0 : ref2.getBoundingClientRect().left) + (direction === "to-right" ? -70 : -45),
                top: 0
            });
        }
    }, [
        currentFocusedSectionItem,
        overflowSectionCount,
        direction
    ]);
    if (!overflowSectionCount) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: (0,_object_spread/* default */.Z)({
            width: "".concat(containerWidth, "px")
        }, styles),
        className: "tw-flex tw-justify-center tw-gap-[6px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: dotsContainerRef,
            className: "no-scrollbar tw-flex tw-items-center tw-gap-[6px] tw-overflow-x-auto",
            children: Array.from(Array(overflowSectionCount).keys()).map(function(_, index) {
                var isSelected = currentFocusedSectionItem === index + 1;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: function(node) {
                        return dotsRef.current[index] = node;
                    },
                    className: classnames_default()("tw-h-[5px] tw-shrink-0 tw-rounded-[3px]  tw-transition-all", dimensions.height, !isSelected ? dimensions.width : dimensions.widthOfSelected || dimensions.width, !isSelected && "tw-bg-[#111C36]/[0.25]"),
                    style: isSelected ? {
                        background: progressIndicatorColor
                    } : {}
                }, index);
            })
        })
    });
}
function useGetChevronComponent(param) {
    var type = param.type, onNextArrowClick = param.onNextArrowClick, onPrevArrowClick = param.onPrevArrowClick, scrollPercentage = param.scrollPercentage, isMobile = param.isMobile, colorConfig = param.colorConfig, _dimensions = param.dimensions, dimensions = _dimensions === void 0 ? {
        width: {
            mobile: "28px",
            desktop: "36px"
        },
        height: {
            mobile: "28px",
            desktop: "36px"
        }
    } : _dimensions;
    var styles = function() {
        var styles = {
            border: "",
            borderRadius: "0",
            background: (colorConfig === null || colorConfig === void 0 ? void 0 : colorConfig.shapeColor) || ""
        };
        switch(type){
            case "circular":
                styles.border = "0.75px solid #111C361F";
                styles.borderRadius = "20";
                break;
            case "rounded":
                styles.border = "0.75px solid #111C361F";
                styles.borderRadius = "5";
                break;
            case "square":
                styles.border = "0.75px solid #111C361F";
                break;
            default:
                styles.background = "";
                break;
        }
        return styles;
    }();
    var removeBorder = type === "onlyArrow";
    var iconProps = {
        width: dimensions.width[isMobile ? "mobile" : "desktop"],
        height: dimensions.height[isMobile ? "mobile" : "desktop"],
        removeBorder: removeBorder,
        bgColor: styles.background,
        borderRadius: styles.borderRadius
    };
    return {
        LeftArrow: function(_param) {
            var _isVisible = _param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible, props = (0,_object_without_properties/* default */.Z)(_param, [
                "isVisible"
            ]);
            return isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                className: classnames_default()(// isMobile ? 'tw-h-[28px]' : 'tw-h-[36px]',
                "tw-pointer-events-auto", scrollPercentage ? "tw-cursor-pointer" : " ", props.className),
                style: merge_default()(props.style, {
                    width: dimensions.width[isMobile ? "mobile" : "desktop"],
                    height: dimensions.height[isMobile ? "mobile" : "desktop"]
                }, !removeBorder ? {
                    boxShadow: "0px 0px 1.5px 0px #111C3633",
                    borderRadius: styles.borderRadius + "px"
                } : {}),
                onClick: onPrevArrowClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* RightArrowIcon */.A, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: "tw-rotate-180"
                }, iconProps), {
                    arrowColor: scrollPercentage <= utils/* INITIAL_SCROLL_PERCENTAGE */.Sk ? (0,common/* hexToRgba */.a7)(colorConfig.arrowColor, 0.5) : colorConfig.arrowColor
                }))
            }));
        },
        RightArrow: function(_param) {
            var _isVisible = _param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible, props = (0,_object_without_properties/* default */.Z)(_param, [
                "isVisible"
            ]);
            return isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                className: classnames_default()("tw-pointer-events-auto", // isMobile ? 'tw-h-[28px]' : 'tw-h-[36px]',
                scrollPercentage >= 100 ? "" : "tw-cursor-pointer ", props.className),
                style: merge_default()(props.style, props.style, {
                    width: dimensions.width[isMobile ? "mobile" : "desktop"],
                    height: dimensions.height[isMobile ? "mobile" : "desktop"]
                }, !removeBorder ? {
                    boxShadow: "0px 0px 1.5px 0px #111C3633",
                    borderRadius: styles.borderRadius + "px"
                } : {}),
                onClick: onNextArrowClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* RightArrowIcon */.A, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, iconProps), {
                    arrowColor: scrollPercentage >= 100 ? (0,common/* hexToRgba */.a7)(colorConfig.arrowColor, 0.5) : colorConfig.arrowColor
                }))
            }));
        }
    };
}


/***/ }),

/***/ 869466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ RightArrowIcon; },
/* harmony export */   "G": function() { return /* binding */ DownArrowIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(999534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);




function RightArrowIcon(_param) {
    var _arrowColor = _param.arrowColor, arrowColor = _arrowColor === void 0 ? "#000" : _arrowColor, _bgColor = _param.bgColor, bgColor = _bgColor === void 0 ? "#fff" : _bgColor, _borderRadius = _param.borderRadius, borderRadius = _borderRadius === void 0 ? "5" : _borderRadius, _removeBorder = _param.removeBorder, removeBorder = _removeBorder === void 0 ? false : _removeBorder, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "arrowColor",
        "bgColor",
        "borderRadius",
        "removeBorder"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "24",
                height: "24",
                fill: bgColor,
                rx: borderRadius,
                transform: "matrix(-1 0 0 1 24 0)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "23.25",
                height: "23.25",
                x: "-0.375",
                y: "0.375",
                stroke: arrowColor,
                strokeOpacity: "0.12",
                strokeWidth: !removeBorder ? "0.75" : "0",
                rx: borderRadius,
                transform: "matrix(-1 0 0 1 23.25 0)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_304_3140)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    stroke: arrowColor,
                    strokeWidth: "1.5",
                    d: "M10.39 7.885l3.88 3.88-3.88 3.878"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_304_3140",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H13.714V13.714H0z",
                        transform: "matrix(0 1 1 0 5.14 5.143)"
                    })
                })
            })
        ]
    }));
}
function DownArrowIcon(_param) {
    var _arrowColor = _param.arrowColor, arrowColor = _arrowColor === void 0 ? "#fff" : _arrowColor, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "arrowColor"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                        id: "mask0_666_6105",
                        style: {
                            maskType: "alpha"
                        },
                        width: "16",
                        height: "10",
                        x: "0",
                        y: "3",
                        maskUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fill: "#D9D9D9",
                            d: "M0 3H16V13H0z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        mask: "url(#mask0_666_6105)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            stroke: arrowColor,
                            strokeWidth: "1.6",
                            d: "M2.343 5.657L8 11.314l5.657-5.657"
                        })
                    })
                ]
            })
        })
    }));
}


/***/ })

}]);